import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {AbstractRepositoryV2} from 'src/app/modules/core/service/v2/abstractRepositoryV2';
import {PaymentRequestModel} from '../../../api/entity/paymentRequest.model';



@Injectable({providedIn: 'root'})
export class PaymentRequestRepository extends AbstractRepositoryV2<PaymentRequestModel>{
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('PaymentRequest', serviceElementsFactory, injector);
    }
}
